import Theme from 'Theme';
import styled from 'styled-components';

import config from 'config';
import Card from 'components/common/Card';

import {
  fadeInLeft,
  zoomInRotate
} from 'components/Animations';


const BASENAME = config.site.baseName;

const LOGO_PROPS = {
  src: `${BASENAME ? '/' : ''}${BASENAME}/img/logo.png`
};

const LOGO_TEXT_PROPS = {
  src: `${BASENAME ? '/' : ''}${BASENAME}/img/searchlight.png`
};

export const AppIcon = styled.img`
  width: auto;
  height: 4rem;
  border-radius: 0.25rem;
  background-color: #fff;
  padding: 0.25rem;
  border-style:solid;
  border-width: 1px;
  border-color: #eee;
  box-shadow: 0 1px 3px 0 rgba(0,0,0,0.1),0 1px 2px 0 rgba(0,0,0,0.06);

`;

export const IconContain = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #F3F4F6;
  padding: 1.5rem;
  color: #6B7280;
  border-radius: 0.25rem;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const InnerContainer = styled.div`
  flex: 1;
  margin-top: 88px;
  max-width: 640px;

  ${(props) => props.theme.media.sm.max`
    width: 100%;
    margin-top: 0px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
  `}
`;

export const Button = styled.button`
  display: flex;
  width: 100%;
  border: none;
  color: #fff;
  max-width: 340px;
  margin-left: auto;
  margin-right: auto;
  padding: 0em 1em;
  font-weight: 400;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  line-height: 2.2em;
  justify-content: center;
  align-items: center;
  font-family: 'Roboto';
  box-sizing: border-box;
  background-color: ${(props) => props.theme.brandColor};

  ${(props) =>
    props.disabled &&
    `
    color: #a4a4a4;
    background-color: #e5e5e5;
  `}

  ${(props) =>
    props.secondary &&
    `
    background-color: #fff;
    color: rgb(20, 76, 110);
    box-shadow: inset 0px 0px 0px 2px rgb(20, 76, 110);
  `}

  transition: all 0.15s ease-in-out;

  &:hover {
    opacity: 0.8 !important;
  }

  &:active {
    opacity: 0.5 !important;
  }
`;

export const ButtonLabel = styled.span`
  margin-left: 0.5em;
`;

export const Label = styled.div`
  font-size: 0.9em;

  font-weight: 400;
  margin-bottom: 8px;

  color: rgb(1, 52, 83);
  transition: top 0.1s ease-out;
  font-family: ${Theme.primaryFont};

`;

export const CardTitle = styled(Card.Title)`
  margin-bottom: 0.5em;
  display: flex;
  align-items: center;
  background-color: #495e6a0a;
  font-size: 1.2em;
  padding: 0.4em 0.5em;
  color: #18242a;
  border-radius: 2px;
  font-weight: 400;
  box-shadow: 0px 0px 0px 1px #ebeeeec4;
  height: 24px;

  background: #ffffff; /* Old browsers */
  background: -moz-linear-gradient(top, #ffffff 0%, #f9fafa 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    top,
    #ffffff 0%,
    #f9fafa 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to bottom,
    #ffffff 0%,
    #f9fafa 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#f9fafa',GradientType=0 ); /* IE6-9 */
`;

export const Terms = styled.p`
  font-size: 0.865rem;
  color: #9CA3AF;
  line-height: 1.5;
  border-style: solid;
  padding: 1rem;
  border-width: 0px;
  border-color: #e6e6e6;
  background: #fff;
  border-top-width: 1px;
  margin-top: 1.5rem;
`;

export const List = styled.ul`
 text-decoration: none;
 font-size: 0.875em;
`

export const Item = styled.li`
  display: flex;
  line-height: 2rem;
  align-items: center;
  margin-left: -1.5rem;
`

export const SearchLightLogo = styled.img`
  height: 80%;
  ${zoomInRotate}
`;

export const SearchLightText = styled.img`
  height: 100%;
  margin-left: 16px;

  ${fadeInLeft}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  height: 60px;
  padding: 16px;
`;

SearchLightLogo.defaultProps = LOGO_PROPS;
SearchLightText.defaultProps = LOGO_TEXT_PROPS;